import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const SalaryReportLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SalaryReport" */
      './SalaryReport.dynamic'
    ),
  loading: LoadingPageLoadable,
});
